import React, { useEffect } from "react";
import Header from "../organisms/Header";
import Footer from "../organisms/Footer";
import MainSlider from "../organisms/MainSlider";
import SermonSection from "../organisms/SermonSection";
import ColumnSection from "../organisms/ColumnSection";
import AboutSection from "../organisms/AboutSection";
import WorshipSection from "../organisms/WorshipSection";
import OfferingSection from "../organisms/OfferingSection";
import LocationSection from "../organisms/LocationSection";
import { analyticsService } from "../../services/AnalyticsService";
import { useAuth } from "../../util/hook";

const Home = () => {
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    analyticsService.incrementTotalVisitorCount();
  }, []);

  return (
    <>
      <Header />
      <MainSlider />
      <SermonSection />
      <ColumnSection />
      <AboutSection />
      <WorshipSection />
      <OfferingSection />
      <LocationSection />
      <Footer />
    </>
  );
};

export default Home;
